import { HAND_COMBINATIONS_LABELS } from '@lbs/shared-rp-types'
import { TextField } from '@mui/material'
import { FC, Fragment } from 'react'
import { Controller, useFieldArray, UseFormReturn } from 'react-hook-form'
import { formPropsDrawerCrud } from '../../constants/formPropsDrawerCrud'
import { TRpPayoutsFormData } from './schema'
import { Container } from './styles'

type TRpPayoutsFormBaseProps = {
  hookForm: UseFormReturn<TRpPayoutsFormData>
}

const RpPayoutsFormBase: FC<TRpPayoutsFormBaseProps> = (props) => {
  const fieldProps = { ...formPropsDrawerCrud, InputLabelProps: { shrink: true } }

  const {
    control,
    register,
    formState: { errors },
  } = props.hookForm

  const { fields } = useFieldArray({
    control,
    name: 'data',
  })

  return (
    <>
      <TextField
        {...fieldProps}
        {...register('name')}
        label="Имя"
        error={!!errors.name}
        helperText={errors.name?.message}
      />

      <Container>
        {fields
          .filter((item) => !['ACE_KING'].includes(item.combination))
          .map((fieldItem, index) => {
            return (
              <Fragment key={fieldItem.id}>
                <Controller
                  name={`data.${index}.combination`}
                  control={control}
                  render={({ field }) => {
                    return (
                      <TextField
                        {...fieldProps}
                        label="Комбинация"
                        value={field.value ? HAND_COMBINATIONS_LABELS.ru[field.value] : ''}
                        onChange={field.onChange}
                        disabled
                        error={!!errors?.data?.[index]?.combination}
                        helperText={errors?.data?.[index]?.combination?.message}
                      />
                    )
                  }}
                />

                <TextField
                  {...fieldProps}
                  {...register(`data.${index}.multiplier`, {
                    valueAsNumber: true,
                  })}
                  error={!!errors?.data?.[index]?.multiplier}
                  label="Множитель"
                />
              </Fragment>
            )
          })}
      </Container>
    </>
  )
}

export default RpPayoutsFormBase
